import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ViewEncapsulation } from '@angular/core';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-importpartmaster',
  templateUrl: './importpartmaster.component.html',
  styleUrls: ['./importpartmaster.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportpartmasterComponent implements OnInit {
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  searchText: string;
  vRead: string;
  vWrite: string;
  sOnboardingId: string;

  @ViewChild('file')
  myInputVariable: ElementRef;
  constructor(private http: HttpClient, private SpinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('ImportPartRead');
    this.vWrite = localStorage.getItem('ImportPartWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';

      this.sOnboardingId = localStorage.getItem('OnboardingId');
      if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
        Swal.fire('','Please Select A Customer First!');
      }
  }
  public uploadFile = (files) => {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      this.myInputVariable.nativeElement.value = "";
      return;
    }
    this.SpinnerService.show();
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    debugger;
    if (files.length === 0) {
      return;
    }
    debugger;
    var cusId = sessionStorage.getItem('CustomerId');
    let fileToUpload = <File>files[0];
    var vType = fileToUpload.name;
    var vfType = vType.split('.');
    var vExtention = vfType[1];


  //   var file = <File>files[0];
  //   if (file) {
  //   var reader = new FileReader();
  //   reader.onload = function (e) {
  //   var data = e.target.result;
  //   var workbook = XLSX.read(data, { type: 'binary' });
  //   var first_sheet_name = workbook.SheetNames[0];
  //   var dataObjects = XLSX.utils.sheet_to_json(workbook.Sheets[first_sheet_name]);
  //   }
  // }

    if (vExtention != "xlsx") {
      this.isShownError = false;
      this.ErrorMsg = "Invalid FileType, Please Select The xlsx File.";
      return;
    }
    else {
      const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);
      var vLoginId = localStorage.getItem("LoginId");
      var vLoginMail = localStorage.getItem("LoginMail");
      let params = new HttpParams();
      params = params.append('iCClientId', vLoginId);
      params = params.append('sEmail', vLoginMail);
      params = params.append('iOnboardingId', this.sOnboardingId);
      this.http.post(environment.apiUrl + 'ReadData/ImportPartMaster', formData, { params: params }).subscribe(
        (response) => {
          debugger;
        },
        (error) => {
          debugger;
          var vDataError = JSON.stringify(error.error.text);
          var vErrorMsg = vDataError.replace('"', '');
          var vErrorMsg1 = vErrorMsg.replace('"', '');
          this.SpinnerService.hide();
          if (vErrorMsg1 == "Success") {
            ((document.getElementById('myfile') as HTMLInputElement).value) = null;
            this.isShownSuccess = false;
            this.SuccessMsg = "Parts Imported Successfully.";
            return false;
          }
          else if (vErrorMsg1 == "Failed") {
            ((document.getElementById('myfile') as HTMLInputElement).value) = null;
            this.isShownError = false;
            this.ErrorMsg = "Parts Imported Failed, Please try again..";
            return false;
          }
        }
      )

    }
  }
}
